import api from "./api";

export interface ImpersonateResult {
  user_id: number;
  company_id: number;
  access_token: string;
  refresh_token: string;
  name: string;
  login: string;
  profile: string;
  avatar: string;
  expires_in: string;
}

/** ADMIN entra na sessão de outro usuário, sem precisar da senha dele. */
export async function impersonateUser(userId: number): Promise<ImpersonateResult> {
  const { data } = await api.post<ImpersonateResult>(`/auth/impersonate/${userId}`);
  return data;
}
